import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';
import {MieterDaten} from '../../models/mieter-daten.model';
import {PageComponent} from '../../page.component';
import {HttpErrorResponse} from '@angular/common/http';
import {LoginError} from '../../models/login-error.model';
import {MatDialog} from '@angular/material/dialog';
import {LoginWarningDialogComponent} from '../../dialogs/login-warning/login-warning.dialog.component';
import {LoginCreationErrorDialogComponent} from '../../dialogs/login-creation-error/login-creation-error.dialog.component';
import {ValidationService} from '../../services/validation.service';
import {LoginNoMieterDialogComponent} from '../../dialogs/login-no-mieter/login-no-mieter.dialog.component';

@Component({
  selector: 'mp-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends PageComponent implements OnInit {
  loginForm: FormGroup;
  usernameControl = new FormControl('', [Validators.required]);
  passwordControl = new FormControl('', [Validators.required]);
  loading = false;
  hidePassword = true;
  errNotAuthorized: boolean;
  errFailure: boolean;
  errDataCreation: boolean;
  errNotActive: boolean;
  errNoMieter: boolean;
  errString: string;

  constructor(
    private formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private readonly validationService: ValidationService,
    private dialog: MatDialog,
    private router: Router) {
    super();
  }

  canGoBack(): boolean {
    return false;
  }

  isLightPage(): boolean {
    return true;
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: this.usernameControl,
      password: this.passwordControl
    });

    this.resetErrors();
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }

    this.resetErrors();

    this.loading = true;

    const email = this.validationService.sanitizeEmail(this.loginForm.controls.username.value);
    const pwHashed = this.validationService.hashEmailAndPassword(
      this.loginForm.controls.username.value,
      this.loginForm.controls.password.value
    );

    this.apiService.getDataForUser(email, pwHashed)
      .subscribe((apiData: MieterDaten[]) => {
        this.loading = false;
        this.afterLoadingData(apiData);
      }, (err: HttpErrorResponse) => {
        this.loading = false;

        // Account nicht gefunden oder falsche Credentials
        if (err.status === 401) {
          this.errNotAuthorized = true;
          return;
        }

        if (err.status === 422) {
          this.errNoMieter = true;
          this.openLoginNoMieter();
          return;
        }

        this.errFailure = true;
      });
  }

  afterLoadingData(apiData: MieterDaten[]): void {
    if (apiData.length === 1 && apiData[0].status !== 200) {
      this.handleLoginError(apiData[0]);
    } else {
      this.router.navigate(['home']);
    }
  }

  handleLoginError(err: MieterDaten): void {
    // Account noch nicht aktiv
    if (err.status === 412) {
      const loginError: LoginError = err.error;
      const dateStr = new Date(loginError.startDate).toLocaleDateString('de-DE');
      this.errNotActive = true;
      const msgStr = `Ihre Registrierung war erfolgreich. Das Mieterportal steht Ihnen ab dem ${dateStr} zur Verfügung. Sobald erste Verbrauchsinformationen zur Verfügung stehen, erhalten Sie eine Benachrichtigung per E-Mail.`;
      this.openLoginWarning(msgStr);
      return;
    }

    // Daten holen fehlgeschlagen
    if (err.status === 406) {
      this.errDataCreation = true;
      this.openLoginCreationError();
      return;
    }


  }

  openLoginWarning(message: string): void {
    this.dialog.open(LoginWarningDialogComponent, {
      disableClose: true,
      data: {
        message
      }
    });
  }

  openLoginCreationError(): void {
    this.dialog.open(LoginCreationErrorDialogComponent, {
      disableClose: true
    });
  }

  openLoginNoMieter(): void {
    this.dialog.open(LoginNoMieterDialogComponent, {
      disableClose: true
    });
  }

  resetPassword(): void {
    this.router.navigate(['passwort-zuruecksetzen']);
  }

  private resetErrors(): void {
    this.errNotAuthorized = false;
    this.errFailure = false;
    this.errNotActive = false;
    this.errNoMieter = false;
    this.errString = '';
  }
}
